module.exports = __webpack_public_path__ + "img/DSC_7024.55531821.jpg";